export default {
    dark: true, // Ensure dark mode is enabled
    themes: {
        dark: {
            primary: '#e8eaed',
            background: '#0D0B18'
        },
    },
  };